export default function Hero() {
  return (
    <section className="w-full bg-foreground-900">
      <div className="relative w-full h-[520px] md:h-[620px] flex items-center overflow-hidden">
        {/* Background Image Layer */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=A%20beautifully%20styled%20fashion%20product%20flat%20lay%20composition%20on%20a%20light%20cream%20linen%20surface%2C%20featuring%20a%20pair%20of%20white%20sneakers%20a%20folded%20beige%20hoodie%20a%20leather%20watch%20and%20minimalist%20accessories%20arranged%20in%20an%20artistic%20scatter%20pattern%2C%20soft%20diffused%20natural%20window%20lighting%20from%20above%20left%2C%20warm%20neutral%20tones%20throughout%2C%20editorial%20product%20photography%20style%2C%20clean%20Scandinavian%20aesthetic%2C%20sophisticated%20composition%2C%20no%20text%20no%20logos%2C%20serene%20and%20inviting%20atmosphere%20with%20gentle%20shadows&width=1800&height=900&seq=hero-bg-new-40&orientation=landscape"
            alt="Itaobuy Spreadsheet prodotti moda"
            className="w-full h-full object-cover"
            title="Itaobuy Spreadsheet — prodotti moda e shopping online"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40 z-10"></div>
        </div>

        {/* Content Layer */}
        <div className="relative z-20 w-full px-4 md:px-8">
          <div className="max-w-3xl ml-0 md:ml-8">
            <p className="text-white/80 text-xs md:text-sm font-label tracking-widest uppercase mb-4">
              Itaobuy Spreadsheet &bull; Ricerca Prodotti
            </p>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight mb-4">
              Scopri
              <br />
              <span className="italic font-normal">Prodotti</span>
              <br />
              Unici
            </h1>
            <p className="text-white/80 text-sm md:text-base max-w-lg mb-8 leading-relaxed">
              Il database prodotti più completo per lo shopping online. Esplora migliaia di articoli di moda, dalle sneakers agli accessori, con la guida italiana aggiornata.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 rounded-full bg-white text-foreground-950 text-sm font-label font-semibold cursor-pointer whitespace-nowrap hover:bg-gray-100 transition-colors text-center flex items-center justify-center gap-2"
              >
                <span>Esplora il Database</span>
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="/cos-e-itaobuy-spreadsheet"
                className="px-6 py-3 rounded-full border border-white/40 text-white text-sm font-label font-medium cursor-pointer whitespace-nowrap hover:bg-white/10 transition-colors text-center flex items-center justify-center gap-2"
              >
                <span>Leggi la Guida</span>
                <i className="ri-book-open-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}